module.exports = "pegasus/assets/theme6/small/5.jpg";